var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBizSole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed7015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eda215"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8 -7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    transform: "translate(8 7)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.275 -0.392)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(12.725 12.392)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.06 1.149)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.6025390625 17.11155319213867 C 5.154919147491455 17.11155319213867 3.781989097595215 16.33642387390137 2.736639022827148 14.9289436340332 C 1.616749048233032 13.42109394073486 0.9999990463256836 11.36951351165771 0.9999990463256836 9.152103424072266 C 0.9999990463256836 6.79249382019043 1.113409042358398 4.368133544921875 1.936129093170166 2.620893716812134 C 2.460978984832764 1.506263613700867 3.516999006271362 0.02441362664103508 6.614748954772949 0.02441362664103508 C 9.709029197692871 0.02441362664103508 10.75924873352051 1.504903674125671 11.28003883361816 2.618513584136963 C 12.09301948547363 4.356903553009033 12.20507907867432 6.786033630371094 12.20507907867432 9.152103424072266 C 12.20507907867432 11.36951351165771 11.58832931518555 13.42109394073486 10.46843910217285 14.9289436340332 C 9.423089027404785 16.33642387390137 8.050159454345703 17.11155319213867 6.6025390625 17.11155319213867 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.614748954772949 1.0244140625 C 5.548159122467041 1.0244140625 4.690858840942383 1.21860408782959 4.066638946533203 1.601573944091797 C 3.550708770751953 1.918113708496094 3.149748802185059 2.390883445739746 2.840848922729492 3.046903610229492 C 2.099899291992188 4.620473861694336 1.999999046325684 7.01616382598877 1.999999046325684 9.152103424072266 C 1.999999046325684 11.15623378753662 2.546718597412109 12.99607372283936 3.53943920135498 14.33270359039307 C 4.391408920288086 15.47981357574463 5.479238986968994 16.11155319213867 6.6025390625 16.11155319213867 C 7.725839138031006 16.11155319213867 8.813669204711914 15.47981357574463 9.66563892364502 14.33270359039307 C 10.65835952758789 12.99607372283936 11.20507907867432 11.15623378753662 11.20507907867432 9.152103424072266 C 11.20507907867432 2.923403739929199 10.13256931304932 1.0244140625 6.614748954772949 1.0244140625 M 6.614748954772949 -0.9755859375 C 12.68397903442383 -0.9755859375 13.20507907867432 4.103123664855957 13.20507907867432 9.152103424072266 C 13.20507907867432 14.20107364654541 10.24901962280273 18.11155319213867 6.6025390625 18.11155319213867 C 2.956059455871582 18.11155319213867 -9.5367431640625e-07 14.20107364654541 -9.5367431640625e-07 9.152103424072266 C -9.5367431640625e-07 4.103123664855957 0.5455093383789062 -0.9755859375 6.614748954772949 -0.9755859375 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.559,19.816h0A5.687,5.687,0,0,0,16.3,17.061c1.969-3.068,2.354-6.094,2.354-9.907,0,0-.183-6.832-7.09-6.832",
    transform: "translate(3.162 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.258,19.816h0a5.687,5.687,0,0,1-4.744-2.755c-1.968-3.068-2.354-6.094-2.354-9.907,0,0,.184-6.832,7.09-6.832",
    transform: "translate(1.463 -0.321)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.765,14.08c.005.231,0,.452-.013.663a4.123,4.123,0,0,1-3.214,3.73l-3.463.868a5.5,5.5,0,0,0-3.607,3.446A5.682,5.682,0,0,0,1.173,24.1L.361,31.128H9.839",
    transform: "translate(-0.361 4.267)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.088,14.08c-.005.231,0,.452.013.663a4.123,4.123,0,0,0,3.214,3.73l3.463.868a5.5,5.5,0,0,1,3.607,3.446A5.681,5.681,0,0,1,24.68,24.1l.812,7.027H16.177",
    transform: "translate(3.957 4.267)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.26 21.865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.11,18.664l1.9,10.8-3.454,3.947",
    transform: "translate(-8.099 -16.498)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,18.664l-1.9,10.8,3.454,3.947",
    transform: "translate(-8.907 -16.498)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.753,16.849,11.553,18l-2.2-1.151",
    transform: "translate(-8.1 -16.849)",
    fill: "none",
    stroke: "#216bc5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.777,24.676l-.438,2.532,1.648,1.911,1.648-1.911L13.2,24.676a3.11,3.11,0,0,1-2.421,0",
    transform: "translate(-8.482 -15.066)",
    fill: "url(#a)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBizSole);
export default __webpack_public_path__ + "static/media/biz-sole.baf26d9f11cb728f92f172fb7f49f675.svg";
export { ForwardRef as ReactComponent };